import { NgModule } from '@angular/core';
import { HasAuthorityDirective } from './access.directive';

@NgModule({
    imports: [],
    exports: [HasAuthorityDirective],
    declarations: [HasAuthorityDirective],
    providers: [],
})
export class SecurityModule { }